import { config } from 'config';
import useSWR from 'swr';

export enum CoreApiPaymentsStatus {
  ACTIVE = 'active',
  INACTIVE_SOON = 'inactive_soon',
  INACTIVE = 'inactive',
}

export type EdgeRetrievePaymentStatusResponse = {
  payments_status: CoreApiPaymentsStatus;
};

export const usePaymentStatus = (business_slug: string) => {
  const url = `${config.apiUrlV3}/web/payments/status?slug=${business_slug}`;

  return useSWR<EdgeRetrievePaymentStatusResponse>(url);
};
